import React from "react";
import PropTypes from 'prop-types';
import {siteURL} from "./LinkTracking";

export const RequiredFieldMessage = () => (
    <div className={'required-field-heading'}>
        <span>*</span>Required fields
    </div>
)

export const RequiredAstrix = () => <span className={'invalid'}>*</span>;

export const FAQLink = ({ target, title }) => (
    <div className={'modal-link-wrapper'}>
        <a href={'#'}
           data-toggle="modal"
           data-target={`#${target}`}
           className={'mr-4 modal-link'}
           onClick={(e) => {
               e.preventDefault();
               linkTrack('judging_criteria_faqs', siteURL)
           }}
        >{title ?? 'Judging Criteria & FAQs'}</a>
    </div>
)
export const TermsConditionsLink = ({target}) => (
    <div className={'modal-link-wrapper'}>
        <a href={'#'}
           onClick={() => linkTrack('terms_conditions', siteURL)}
           data-toggle="modal"
           data-target={`#${target}`}
           className={'modal-link'}
        >Terms & Conditions</a>
    </div>
)

export const FormSubmissionError = ({message}) => {
    return (
        <div className={'submission-form-error-wrapper'}>
            <div className={'d-flex align-items-center justify-content-center'}>
                <img src={'/_resources/themes/anz-courtside/dist/images/icon-warning-alert.svg'} alt={'error icon'}/>
            </div>
            <div className={'submission-form-errors'}>{message}</div>
        </div>
    )
}

FormSubmissionError.prototype = {
    message: PropTypes.string.required
}
